import { createSvgIcon } from '@mui/material';

const Scanner = createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8H3V10H2V8Z" fill="black" />
    <path d="M11 8H12V10H11V8Z" fill="black" />
    <path d="M7 8V10H7.5V8H7Z" fill="black" />
    <path d="M16 8V10H15.5V8H16Z" fill="black" />
    <path
      d="M1 4V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H5M1 14V15C1 15.5304 1.21071 16.0391 1.58579 16.4142C1.96086 16.7893 2.46957 17 3 17H5M13 1H15C15.5304 1 16.0391 1.21071 16.4142 1.58579C16.7893 1.96086 17 2.46957 17 3V4M13 17H15C15.5304 17 16.0391 16.7893 16.4142 16.4142C16.7893 16.0391 17 15.5304 17 15V14M2 8H3V10H2V8ZM7 8V10H7.5V8H7ZM11 8H12V10H11V8ZM16 8V10H15.5V8H16Z"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Scanner',
);

export default Scanner;
